import { Map } from 'immutable';
import BankSearch from './presenter';
import { connect } from '../../../common/react-redux';
import { update, setFilter, toggle } from '../../../common/actions/bankSearch';
import { toggle as toggleUI } from '../../../common/actions/ui';
import { BANKS_SEARCH_FILTER_KEY, BANKS_TOGGLE_INTERACTIONS_KEY } from '@instructure/quiz-common';
function mapStateToProps(state, props) {
  var searching = state.getIn(['ui', 'searching'], false);
  var search = state.get('bankSearch', Map());
  var showFilters = state.getIn(['ui', BANKS_SEARCH_FILTER_KEY]);
  var allInteractions = state.getIn(['ui', BANKS_TOGGLE_INTERACTIONS_KEY]);
  return {
    allInteractions: allInteractions,
    searching: searching,
    search: search,
    showFilters: showFilters
  };
}
var mapDispatchToProps = {
  toggle: toggle,
  toggleFilters: function toggleFilters() {
    return toggleUI(BANKS_SEARCH_FILTER_KEY);
  },
  toggleAllInteractions: function toggleAllInteractions() {
    return toggleUI(BANKS_TOGGLE_INTERACTIONS_KEY);
  },
  setFilter: setFilter,
  update: update
};
export default connect(mapStateToProps, mapDispatchToProps)(BankSearch);